////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const addItemCatalog = {
	postBindCatalog: (
		filters = {},
		queryParams = {
			page: '0',
			size: '250',
			nameDir: 'asc',
			sort: 'dateEnabled',
			sort_2: 'distributionGroup.company.labelToDisplay',
			nameDir_2: 'asc',
		}
	) => ({
		type: ActionsTypes.POST_BIND_CATALOG,
		payload: {
			filters,
			queryParams,
		},
	}),
	postBindCatalogSuccess: (data) => ({
		type: ActionsTypes.POST_BIND_CATALOG_SUCCESS,
		payload: {
			data,
		},
	}),
	postBindCatalogFailure: (error) => ({
		type: ActionsTypes.POST_BIND_CATALOG_FAILURE,
		payload: {
			error,
		},
	}),

	putLinkCatalogItem: (idItem) => ({
		type: ActionsTypes.PUT_LINK_CATALOG_ITEM,
		payload: {
			idItem,
		},
	}),
	putLinkCatalogItemSuccess: (data) => ({
		type: ActionsTypes.PUT_LINK_CATALOG_ITEM_SUCCESS,
		payload: {
			data,
		},
	}),
	putLinkCatalogItemFailure: (error) => ({
		type: ActionsTypes.PUT_LINK_CATALOG_ITEM_FAILURE,
		payload: {
			error,
		},
	}),

	putUnlinkCatalogItem: (idItem) => ({
		type: ActionsTypes.PUT_UNLINK_CATALOG_ITEM,
		payload: {
			idItem,
		},
	}),
	putUnlinkCatalogItemSuccess: (data) => ({
		type: ActionsTypes.PUT_UNLINK_CATALOG_ITEM_SUCCESS,
		payload: {
			data,
		},
	}),
	putUnlinkCatalogItemFailure: (error) => ({
		type: ActionsTypes.PUT_UNLINK_CATALOG_ITEM_FAILURE,
		payload: {
			error,
		},
	}),
}

export default addItemCatalog
